// Module
var code = "<div class=\"ib-avios-slider__content ib-avios-slider__content--slider\">\n    <rzslider rz-slider-model=\"pmtSliderCtrl.discount_avios.value\" rz-slider-options=\"pmtSliderCtrl.discount_avios.options\">\n    </rzslider>\n</div>";
// Exports
module.exports = code;